<template>
  <label class="material-checkbox" :class="{'form-checkbox': formStyle}">
    <input type="checkbox" v-model="checked" :disabled="disabled">
    <span>{{ label }}</span>
  </label>
</template>

<script>

export default {
  name: 'Checkbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    formStyle: {
      type: Boolean,
      default: false,
    },
    grayed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: this.value,
      disabled: this.grayed,
    };
  },
  watch: {
    grayed(val) {
      this.disabled = val;
    },
    value(val) {
      this.checked = val;
    },
    checked(checked) {
      this.$emit('input', checked);
    },
  },
};

</script>

<style scoped>

:root {
  --material-onsurface-rgb: 0, 0, 0;
}

.form-checkbox {
  margin-left: 30%;
}

.material-checkbox {
  z-index: 0;
  position: relative;
  display: inline-block;
  line-height: 1.5;
}

.material-checkbox > input {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: -1;
  position: absolute;
  left: -10px;
  top: -8px;
  display: block;
  margin: 0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.6);
  box-shadow: none;
  outline: none;
  opacity: 0;
  transform: scale(1);
  pointer-events: none;
  transition: opacity 0.3s, transform 0.2s;
}

.material-checkbox > span {
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

/* Box */

.material-checkbox > span::before {
  content: "";
  display: inline-block;
  box-sizing: border-box;
  margin: 3px 6px 3px 1px;
  border: 2px solid rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  width: 18px;
  height: 18px;
  vertical-align: top;
  transition: border-color 0.2s, background-color 0.2s;
}

/* Checkmark */

.material-checkbox > span::after {
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 1px;
  width: 10px;
  height: 5px;
  border: solid 2px transparent;
  border-right: none;
  border-top: none;
  transform: translate(3px, 4px) rotate(-45deg);
  box-sizing: content-box;
}

/* Checked, Indeterminate */

.material-checkbox > input:checked,
.material-checkbox > input:indeterminate {
  background-color: #1c9be6;
}

.material-checkbox > input:checked + span::before,
.material-checkbox > input:indeterminate + span::before {
  border-color: #1c9be6;
  background-color: #1c9be6;
}

.material-checkbox > input:checked + span::after,
.material-checkbox > input:indeterminate + span::after {
  border-color: #ffffff;
}

.material-checkbox > input:indeterminate + span::after {
  border-left: none;
  transform: translate(4px, 3px);
}

/* Hover, Focus */

.material-checkbox:hover > input {
  opacity: 0.04;
}

.material-checkbox > input:focus {
  opacity: 0.12;
}

.material-checkbox:hover > input:focus {
  opacity: 0.16;
}

/* Active */

.material-checkbox > input:active {
  opacity: 1;
  transform: scale(0);
  transition: transform 0s, opacity 0s;
}

.material-checkbox > input:active + span::before {
  border-color: #1c9be6;
}

.material-checkbox > input:checked:active + span::before {
  border-color: transparent;
  background-color: rgba(0, 0, 0, 0.6);
}

/* Disabled */

.material-checkbox > input:disabled {
  opacity: 0;
}

.material-checkbox > input:disabled + span {
  color: rgba(0, 0, 0, 0.38);
  cursor: initial;
}

.material-checkbox > input:disabled + span::before {
  border-color: currentColor;
}

.material-checkbox > input:checked:disabled + span::before,
.material-checkbox > input:indeterminate:disabled + span::before {
  border-color: transparent;
  background-color: currentColor;
}

</style>
